<template>
  <div class="container">
    <table-datatable />
  </div>
</template>

<script>
// import {
//   save_configuration,
//   get_configuration,
//   post,
//   error_message,
//   success_message,
// } from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import TableDatatable from "./table_datatable/Index.vue";

export default {
  name: "RestaurantTables",
  components: { GenericDropdown, TableDatatable },
  data() {
    return {
      meta: {},
    };
  },
  methods: {},
  created() {},
};
</script>

<style></style>
